import { defineEntityOwner } from './types';

export const demandOwnerDescriptor = defineEntityOwner('demand', {
  owningService: 'demand',
  clientPackage: null,
  cdcTopic: 'demand-data-changes',
  resolveLink: (entityId, ctx) =>
    `/org-id/${ctx.organizationId}/intake/demands?demandId=${entityId}`,
  resolveLabels: null,
});
